import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, LL_H_C, LL_V_L, SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_Action, DBDef_OrderGroup, PreconditionIndex } from '@app/pathway-shared';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { ModuleFE_Action } from '../action/index.js';
import { ModuleFE_OrderGroup } from '../order-group/index.js';
import { ModuleFE_Tag } from '@app/hcs-frontend';
import { ModuleFE_PathwayState } from './ModuleFE_PathwayState.js';
const Props_PreconditionTimeConstraintIndex = {
    adapter: SimpleListAdapter(PreconditionIndex, item => _jsx(_Fragment, { children: item.item })),
    placeholder: 'Select Precondition Index',
    caret: DropDown_DefaultCaret
};
export const DropDown_PreconditionTimeConstraintIndex = TS_DropDown.prepare(Props_PreconditionTimeConstraintIndex);
const Props_DropDown_Precondition = {
    placeholder: 'Choose a precondition',
    pointerProps: {
        [DBDef_Action.dbKey]: {
            module: ModuleFE_Action,
            mapper: order => [order.item.name],
            renderer: order => {
                const tags = ModuleFE_Tag.getTagsLabelByTagGroups(order.item.tagGroups);
                return _jsxs(LL_V_L, { className: 'precondition-entry', children: [_jsxs(LL_H_C, { className: 'entry-label', children: ["[Order] ", order.item.name ?? 'N/A'] }), _jsx(LL_H_C, { className: 'entry-tags', children: tags.map(tag => _jsx("div", { style: { fontSize: '8px', padding: '4px', borderRadius: '5px', border: '1px solid #DEE4EF', background: '#E3E9F2', marginTop: '5px' }, className: tag.className, children: tag.label }, tag.label)) })] });
            },
        },
        [DBDef_OrderGroup.dbKey]: {
            module: ModuleFE_OrderGroup,
            mapper: group => [group.item.name],
            renderer: group => {
                const tags = ModuleFE_Tag.getTagsLabelByTagGroups(group.item.tagGroups);
                return _jsxs(LL_V_L, { className: 'precondition-entry', children: [_jsxs(LL_H_C, { className: 'entry-label', children: ["[Group] ", group.item.name ?? 'N/A'] }), _jsx(LL_H_C, { className: 'entry-tags', children: tags.map(tag => _jsx("div", { style: { fontSize: '8px', padding: '4px', borderRadius: '5px', border: '1px solid #DEE4EF', background: '#E3E9F2', marginTop: '5px' }, className: tag.className, children: tag.label }, tag.label)) })] });
            },
        },
    },
};
export const DropDown_Precondition = GenericDropDownV3.prepare_DBPointers(Props_DropDown_Precondition);
const Props_DropDown_PathwayState = {
    module: ModuleFE_PathwayState,
    modules: [ModuleFE_PathwayState],
    mapper: item => [item.label ?? item.name],
    placeholder: 'Choose a pathway state',
    renderer: item => _jsx(_Fragment, { children: item.label ?? item.name })
};
export const DropDown_PathwayState = GenericDropDownV3.prepare(Props_DropDown_PathwayState);
//# sourceMappingURL=ui-components.js.map